import React, {useState} from "react";
import {
    Create,
    FormTab,
    TextInput,
    TabbedForm,
    Toolbar,
    ReferenceInput,
    NumberInput
} from 'react-admin';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from "@material-ui/core";
import SaveIcon from '@material-ui/icons/Save';


const useStyles = makeStyles((theme) => ({
    estado_civil: {display: 'inline-block', width: 200, marginLeft: 8},
}));

const PostCreateToolbar = props => {
    return (
        <Toolbar {...props} >

        </Toolbar>
    )

};

const validateCreate = (values) => {
    const errors = {};

    var w_estado_civil = values.estado_civil

    if (w_estado_civil===undefined) {
        errors.estado_civil = ['El campo Código es requerido'];
    }else {
        if (w_estado_civil === null) {
            errors.estado_civil = ['El campo Código es requerido'];
        } else {
            w_estado_civil = w_estado_civil.trim()
            if (w_estado_civil === '') {
                errors.estado_civil = ['El campo Código es requerido'];
            }
        }
    }


    return errors
};

// redirect to the related Author show page
const redirect = (basePath, id, data) => `/EstadoCivil`;

const EstadoCivilCreate = props => {
    const classes = useStyles();

    const PostTitle = ({record}) => {
        return <span>Alta de Estado Civil</span>;
    };

    return (
        <Create title={<PostTitle/>} {...props}>
            <TabbedForm
                // toolbar={<PostCreateToolbar />} validate={validateCreate} redirect={redirect}
            >
                {/*Datos*/}
                <FormTab label="DATOS ESTADO CIVIL">
                    <TextInput
                        label="Estado Civil"
                        source="estado_civil"
                        formClassName={classes.estado_civil}
                        placeholder="Ingrese Estado Civil"
                        helperText="Estado Civil"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />

                    <br/>

                </FormTab>
            </TabbedForm>
        </Create>
    )
};
export default EstadoCivilCreate;


